import { action } from 'easy-peasy';
import { IActionSetReleases } from '../types';

const setReleases: IActionSetReleases = action((state, payload) => {
  const { items, pagination } = payload;

  state.list = items;

  if (pagination) {
    state.pagination.total = pagination.total;
    state.pagination.pageNumber = pagination.pageNumber;
    state.pagination.pageSize = pagination.pageSize;
  }
});

export default setReleases;
